import React, { useRef } from 'react';
var VeltCommentSidebarV2ListGroupHeaderCount = function (props) {
    var group = props.group, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-list-group-header-v2-count", { ref: ref, group: group ? (typeof group === 'object' ? JSON.stringify(group) : group) : undefined, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2ListGroupHeaderCount;
